<template lang="pug">
  form-card(
    :title="titlePrefix + $i18n.t('db.models.formulario')"
    :invalid='invalid'
    :resource='current'
    :loading='loading'
  )
    a.btn.btn-link.float-right(@click='clone' slot='header-right' v-if='!isNew')
      i.icon.icon-copy
      |&nbsp;Duplicar formulário
    div(v-if='current')
      .columns
        .column
          form-group(:label="$i18n.tModel('formulario.descricao')" :validation='$v.current.descricao')
            input.form-input#input-example-1(type='text' v-model='$v.current.descricao.$model' :placeholder="$i18n.tModel('formulario.descricao')")
        .column
          form-group(:label="$i18n.tModel('formulario.tipo')" :validation='$v.current.tipo')
            select.form-select(v-model='$v.current.tipo.$model')
              option(v-for="(v, k) in tipos" :value="k") {{v}}
      .columns.pt-2
        .column
          h4.text-primary
            | {{$i18n.tModel('formulario.checklist')}}
        .column(v-if="templates.length > 0")
          .float-right
            .dropdown.dropdown-right
              a.btn.btn-sm.btn-link.dropdown-toggle(tabindex='0')
                | Usar template
                i.icon.icon-caret
              ul.menu
                li.menu-item(v-for="template in templates")
                  a.nowrap.c-hand(@click="usarTemplate(template.checklist)") {{template.label}}
      checklist(v-model='checklist_array' ref='checklistRef' :tipo-formulario="current.tipo")
    div(slot='footer' v-if='current')
      span(v-if='current.id')
        btn-logs(entityName='Formulario', :entityId='current.id' v-acl:allowed.admin.logs.index)
      button.btn.btn-primary(@click="save" :class="{loading: loading}" :disabled='invalid || loading') {{$i18n.t('views.buttons.save.label')}}

</template>

<script>
import Checklist from '@/components/checklist/Index.vue'
import Formulario from '@/models/Formulario'
import formMixin, { vuexDefaultMapping } from '@/mixins/form'
import { deepClone } from 'paliari-js-utils'
import { arrayToHash, hashToArray } from '@/components/checklist/converter'
import templates from './templates'

const formMixinModified = Object.assign({}, formMixin, { created() {} })

export default {
  components: { Checklist },
  mixins: [formMixinModified],
  vuex: { formularios: vuexDefaultMapping },

  data() {
    return {
      checklist_array: [],
    }
  },

  validations: {
    current: Formulario.validations,
  },

  computed: {
    tipos() {
      return this.$i18n.t('enums.db.enum_formulario_tipo')
    },

    templates() {
      return templates.filter(p => p.tipoFormulario.includes(this.current.tipo))
    },
  },

  methods: {
    beforeSave() {
      const errors = this.$refs.checklistRef.getErrors()
      if (errors) {
        throw new Error(errors)
      }
      this.$set(this.current, 'checklist', arrayToHash(this.checklist_array))
    },

    newModel(p) {
      return new Formulario(p)
    },

    usarTemplate(template) {
      const options = {
        title: 'Usar template?',
        cancelLabel: 'Cancelar',
        okLabel: 'Usar template',
      }
      this.$dialogs
        .confirm('O template irá substituir o checklist atual', options)
        .then(res => {
          if (res.ok) this.checklist_array = hashToArray(template())
        })
    },

    clone() {
      this.$delete(this.current, 'id')
      this.$set(this.current, 'descricao', `Cópia - ${this.current.descricao}`)
      this.$router.replace({
        name: 'app.parametros.servicos.formularios.form',
        params: { id: 'new' },
      })
    },
  },

  created() {
    if (this.isNew) {
      this.current = this.newModel()
    } else {
      return this.fetchOne(this.$route.params.id)
        .then(res => {
          this.current = this.newModel(deepClone(res))
          this.checklist_array = hashToArray(this.current.checklist)
        })
        .catch(e => {
          this.$toaster.error(e.message)
        })
    }
  },
}
</script>
